<template>
  <div style="padding:50px">
      <el-form ref="inforForm" :model="inforForm" label-position="left" label-width="72px" :rules="rule" >
        <el-form-item label="姓名:" prop="name">
          <el-input v-model.trim="inforForm.name" maxlength="10" show-word-limit size="small" style="width:500px" />
        </el-form-item>
        <el-form-item label="性别:">
          <el-radio-group v-model="inforForm.sex">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手机号:" >
          {{inforForm.username}}
        </el-form-item>
        <el-form-item label="邮箱:" >
          <el-input v-model.trim="inforForm.email" maxlength="40" show-word-limit size="small" style="width:500px" />
        </el-form-item>
        <el-form-item label="注册时间:">
          {{inforForm.createTime}}
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" size="small">修改</el-button>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
import request from "@/commonService/userCenter-service";
import { mapState } from 'vuex';
const newEmptyInforForm = () => ({
  name:"",
  sex:"",
  username:"",
  createTime:"",
  userId:'',
  email: ''
});
export default {
  data(){
    return{
      inforForm:newEmptyInforForm(),
      rule:{
        name: [{required: true,message: "请输入姓名",trigger: "blur"}],
      }
    }
  },
  computed:{
    ...mapState({
      name: (state) => state.user.name,
      userInfo: (state) => state.user.userInfo,
    })
  },
  created(){
    this.getUser()
  },
  methods:{
    async getUser(){
      const { data } =await request.getUserInfo();
      this.inforForm=data;
    },
    async onSubmit(){
      await this.$refs.inforForm.validate();
      const { name,sex,username,createTime,userId, email}=this.inforForm,
        params={name,sex,username,createTime,userId, email};
      const res =await request.updateUserInfo(params);
      if(res.result=="0") this.$message.success("修改成功");
      await this.getUser();
      var data = this.userInfo;
      data.name = this.inforForm.name;
      this.$store.commit("SET_USERINFO",data)
      this.$store.commit("SET_NAME",this.inforForm.name)
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
